module.exports = __webpack_public_path__ + "img/yucheng.9ec774bb.png";